// Main wrapper for the exam environment. Handles layout, context, and full-screen mode.
import React, { useRef } from 'react';
import {
  Box,
  ThemeProvider,
  createTheme,
  CssBaseline
} from '@mui/material';
import { ExamProvider } from './ExamContext';

const ExamLayout = ({ children, initialExam }) => {
  const layoutRef = useRef(null);

  // Create exam-specific theme
  const examTheme = createTheme({
    palette: {
      mode: 'light',
      primary: { main: '#1976d2' },
      secondary: { main: '#9c27b0' },
      background: { 
        default: '#f8fafc',
        paper: '#ffffff'
      }
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif'
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 600
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={examTheme}>
      <CssBaseline />
      <ExamProvider initialExam={initialExam}>
        <Box
          ref={layoutRef}
          sx={{
            minHeight: '100vh',
            bgcolor: 'background.default',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
          }}
        >
          {children}
        </Box>
      </ExamProvider>
    </ThemeProvider>
  );
};

export default ExamLayout;
